import { NgModule } from "@angular/core";

import { MainComponent } from "./main.component";
import { sharedModule } from "src/app/shared/shared.module";
import { AddHoldingEntryComponent } from "./add-holding-entry/add-holding-entry.component";
import { SelectingHoldingComponent } from "./selecting-holding/selecting-holding.component";
import { ChooseHoldingAndCompanyComponent } from "./choose-holding-and-company/choose-holding-and-company.component";
import { TimesheetManagementComponent } from './timesheet-management/timesheet-management.component';

@NgModule({
  declarations: [
    MainComponent,
    SelectingHoldingComponent,
    AddHoldingEntryComponent,
    ChooseHoldingAndCompanyComponent,
    TimesheetManagementComponent
  ],
  imports: [sharedModule],
  entryComponents: [AddHoldingEntryComponent, ChooseHoldingAndCompanyComponent, TimesheetManagementComponent]
})
export class mainModule {}
